module.exports = __webpack_public_path__ + "img/equipo.194d2a88.png";